import {
  ShoppingBag, Gem, Package, Tag, Layers, Star, Heart,
  Snowflake, Umbrella, Feather, Wind, Zap, Circle,
  Square, Key, Smartphone, Scissors,
  Leaf, Palette, RefreshCw, Smile,
  Sparkles, Briefcase, Crown, Users, UserCheck, Baby,
  Footprints, Glasses, Ribbon, Watch,
  Backpack,
  Diamond,
  Shirt,
  ShoppingBasket,
  Fan,
  BaggageClaimIcon,
} from "lucide-react";
import React from "react";

/* ================= TYPES ================= */

export interface CategoryItem {
  id: number;
  name: string;
  icon: React.ReactNode;
  image?: any;                // optional photo — falls back to the icon if omitted
  parentId?: number | null;
  superCategoryId?: number;
  audienceIds?: number[];
}


/* ──────────────────────────────────────────────
   ICON HELPER — keeps icon size consistent
   ────────────────────────────────────────────── */
const sz = 18; // default icon size (px)




export const GenderCategories: CategoryItem[] = [
  { id: 1, name: "Women", icon: <Users     size={sz} />, superCategoryId: 1 },
  { id: 2, name: "Men",   icon: <UserCheck size={sz} />, superCategoryId: 1 },
  { id: 3, name: "Kids",  icon: <Baby      size={sz} />, superCategoryId: 1 },
];
/* ═══════════════════════════════════════════════════════════
   FASHION — UNIFIED SUBCATEGORIES
   Shared by every gender/age group in FashionCategories.
   No color / size / other attribute entries live here —
   attributes are handled as filters, not categories.
═══════════════════════════════════════════════════════════ */
export const FashionCategories: CategoryItem[] = [
  { id: 11, name: "Clothing",     icon: <Shirt size={sz} />, image: '/icons/fashion/romper.png' },
  { id: 12, name: "Accessories",  icon: <Gem size={sz} />, image: '/icons/fashion/accessories.png' },
  { id: 13, name: "Jewellery",    icon: <Diamond />, image: '/icons/fashion/jewellery.png' },
  { id: 14, name: "Shoes",        icon: <Footprints />, image: '/icons/fashion/shoes.png' },
  { id: 15, name: "Bags",         icon: <ShoppingBag />, image: '/icons/fashion/bags.png' },
];



/* ───────────────────────────────────────────────────────────
   FashionClothing   (parentId: 11)
   Merged/deduped from Women, Men & Kids ranges.
   ─────────────────────────────────────────────────────────── */
export const FashionClothing: CategoryItem[] = [
  { id: 1104, parentId: 11, name: "School Uniforms",            icon: <Briefcase size={16} /> },
  { id: 1105, parentId: 11, name: "Dresses",                    icon: <Heart size={16} /> },
  { id: 1106, parentId: 11, name: "Tops",                       icon: <Shirt size={16} /> },
  { id: 1107, parentId: 11, name: "T-Shirts",                   icon: <Shirt size={16} /> },
  { id: 1108, parentId: 11, name: "Vests",                      icon: <Shirt size={16} /> },
  { id: 1109, parentId: 11, name: "Shirts",                     icon: <Shirt size={16} /> },
  { id: 1110, parentId: 11, name: "Polo Shirts",                icon: <Shirt size={16} /> },
  { id: 1111, parentId: 11, name: "Knitwear",                   icon: <Feather size={16} /> },
  { id: 1112, parentId: 11, name: "Sweaters",                   icon: <Feather size={16} /> },
  { id: 1113, parentId: 11, name: "Hoodies",                    icon: <Tag size={16} /> },
  { id: 1114, parentId: 11, name: "Sweatshirts",                icon: <Tag size={16} /> },
  { id: 1115, parentId: 11, name: "Jackets",                    icon: <Wind size={16} /> },
  { id: 1116, parentId: 11, name: "Coats",                      icon: <Snowflake size={16} /> },
  { id: 1117, parentId: 11, name: "Skiwear",                    icon: <Fan /> },
  { id: 1118, parentId: 11, name: "Trousers",                   icon: <Layers size={16} /> },
  { id: 1119, parentId: 11, name: "Denim",                      icon: <Square size={16} /> },
  { id: 1120, parentId: 11, name: "Skirts",                     icon: <Circle size={16} /> },
  { id: 1121, parentId: 11, name: "Shorts",                     icon: <Scissors size={16} /> },
  { id: 1122, parentId: 11, name: "Tracksuits",                 icon: <Zap size={16} /> },
  { id: 1123, parentId: 11, name: "Activewear",                 icon: <Zap size={16} /> },
  { id: 1124, parentId: 11, name: "Suits",                      icon: <Briefcase size={16} /> },
  { id: 1125, parentId: 11, name: "Blazers",                    icon: <Briefcase size={16} /> },
  { id: 1126, parentId: 11, name: "Formal Wear",                icon: <Star size={16} /> },
  { id: 1127, parentId: 11, name: "Jumpsuits",                  icon: <Tag size={16} /> },
  { id: 1128, parentId: 11, name: "Playsuits",                  icon: <Tag size={16} /> },
  { id: 1129, parentId: 11, name: "Lingerie",                   icon: <Heart size={16} /> },
  { id: 1130, parentId: 11, name: "Underwear",                  icon: <Heart size={16} /> },
  { id: 1131, parentId: 11, name: "Loungewear",                 icon: <Heart size={16} /> },
  { id: 1132, parentId: 11, name: "Pyjamas",                    icon: <Star size={16} /> },
  { id: 1133, parentId: 11, name: "Nightwear",                  icon: <Star size={16} /> },
  { id: 1134, parentId: 11, name: "Swimwear",                   icon: <Umbrella size={16} /> },
  { id: 1135, parentId: 11, name: "Beachwear",                  icon: <Umbrella size={16} /> },
  { id: 1136, parentId: 11, name: "Bridal",                     icon: <Crown size={16} /> },
];

/* ───────────────────────────────────────────────────────────
   FashionAccessories   (parentId: 12)
   ─────────────────────────────────────────────────────────── */
export const FashionAccessories: CategoryItem[] = [
  { id: 1201, parentId: 12, name: "All Accessories",           icon: <Gem size={16} /> },
  { id: 1202, parentId: 12, name: "Sunglasses",                icon: <Glasses size={16} /> },
  { id: 1203, parentId: 12, name: "Glasses & Frames",          icon: <Glasses size={16} /> },
  { id: 1204, parentId: 12, name: "Belts",                     icon: <Circle size={16} /> },
  { id: 1205, parentId: 12, name: "Hats & Caps",               icon: <Crown size={16} /> },
  { id: 1206, parentId: 12, name: "Scarves",                   icon: <Wind size={16} /> },
  { id: 1207, parentId: 12, name: "Gloves",                    icon: <Feather size={16} /> },
  { id: 1208, parentId: 12, name: "Hair Accessories",          icon: <Ribbon size={16} /> },
  { id: 1209, parentId: 12, name: "Ties & Bow Ties",           icon: <Ribbon size={16} /> },
  { id: 1210, parentId: 12, name: "Pocket Squares",            icon: <Square size={16} /> },
  { id: 1211, parentId: 12, name: "Cufflinks",                 icon: <Gem size={16} /> },
  { id: 1212, parentId: 12, name: "Watches",                   icon: <Watch /> },
  { id: 1213, parentId: 12, name: "Wallets & Cardholders",     icon: <ShoppingBasket size={16} /> },
  { id: 1214, parentId: 12, name: "Purses",                    icon: <ShoppingBasket size={16} /> },
  { id: 1215, parentId: 12, name: "Keyrings & Chains",         icon: <Key size={16} /> },
  { id: 1216, parentId: 12, name: "Make-up Bags",               icon: <BaggageClaimIcon /> },
  { id: 1217, parentId: 12, name: "Phone, Computer & Gadgets", icon: <Smartphone size={16} /> },
  { id: 1218, parentId: 12, name: "Socks & Tights",            icon: <Layers size={16} /> },
];

/* Accessories → Sunglasses (parentId: 1202) */
export const FashionSunglasses: CategoryItem[] = [
  { id: 120201, parentId: 1202, name: "Aviators",         icon: <Glasses size={16} /> },
  { id: 120202, parentId: 1202, name: "Wayfarers",        icon: <Glasses size={16} /> },
  { id: 120203, parentId: 1202, name: "Cat Eye",          icon: <Glasses size={16} /> },
  { id: 120204, parentId: 1202, name: "Round Frames",     icon: <Glasses size={16} /> },
  { id: 120205, parentId: 1202, name: "Oversized",        icon: <Glasses size={16} /> },
  { id: 120206, parentId: 1202, name: "Sport Sunglasses", icon: <Glasses size={16} /> },
  { id: 120207, parentId: 1202, name: "Square Frames",    icon: <Glasses size={16} /> },
];

/* Accessories → Hats & Caps (parentId: 1205) */
export const FashionHats: CategoryItem[] = [
  { id: 120501, parentId: 1205, name: "Baseball Caps",  icon: <Crown size={16} /> },
  { id: 120502, parentId: 1205, name: "Beanies",        icon: <Crown size={16} /> },
  { id: 120503, parentId: 1205, name: "Bucket Hats",    icon: <Crown size={16} /> },
  { id: 120504, parentId: 1205, name: "Wide-Brim Hats", icon: <Crown size={16} /> },
  { id: 120505, parentId: 1205, name: "Fedoras",        icon: <Crown size={16} /> },
  { id: 120506, parentId: 1205, name: "Berets",         icon: <Crown size={16} /> },
];

/* Accessories → Watches (parentId: 1212) */
export const FashionWatches: CategoryItem[] = [
  { id: 121201, parentId: 1212, name: "Analogue Watches", icon: <Watch /> },
  { id: 121202, parentId: 1212, name: "Digital Watches",  icon: <Watch /> },
  { id: 121203, parentId: 1212, name: "Smart Watches",    icon: <Watch /> },
  { id: 121204, parentId: 1212, name: "Luxury Watches",   icon: <Watch /> },
  { id: 121205, parentId: 1212, name: "Sports Watches",   icon: <Watch /> },
];

/* ───────────────────────────────────────────────────────────
   FashionJewellery   (parentId: 13)
   ─────────────────────────────────────────────────────────── */
export const FashionJewellery: CategoryItem[] = [
  { id: 1301, parentId: 13, name: "All Jewellery",  icon: <Diamond /> },
  { id: 1302, parentId: 13, name: "Necklaces",      icon: <Diamond /> },
  { id: 1303, parentId: 13, name: "Earrings",       icon: <Gem size={16} /> },
  { id: 1304, parentId: 13, name: "Rings",          icon: <Circle size={16} /> },
  { id: 1305, parentId: 13, name: "Bracelets",      icon: <Gem size={16} /> },
  { id: 1306, parentId: 13, name: "Chains",         icon: <Key size={16} /> },
  { id: 1307, parentId: 13, name: "Pendants",       icon: <Star size={16} /> },
  { id: 1308, parentId: 13, name: "Brooches",       icon: <Star size={16} /> },
  { id: 1309, parentId: 13, name: "Anklets",        icon: <Gem size={16} /> },
  { id: 1310, parentId: 13, name: "Charms",         icon: <Key size={16} /> },
  { id: 1311, parentId: 13, name: "Sets",           icon: <Diamond /> },
  { id: 1312, parentId: 13, name: "Fine Jewellery", icon: <Crown size={16} /> },
];

/* Jewellery → Necklaces (parentId: 1302) */
export const FashionNecklaces: CategoryItem[] = [
  { id: 130201, parentId: 1302, name: "Gold Necklaces",    icon: <Diamond /> },
  { id: 130202, parentId: 1302, name: "Silver Necklaces",  icon: <Diamond /> },
  { id: 130203, parentId: 1302, name: "Pendant Necklaces", icon: <Star size={16} /> },
  { id: 130204, parentId: 1302, name: "Chokers",           icon: <Diamond /> },
  { id: 130205, parentId: 1302, name: "Layered Necklaces", icon: <Diamond /> },
];

/* Jewellery → Rings (parentId: 1304) */
export const FashionRings: CategoryItem[] = [
  { id: 130401, parentId: 1304, name: "Engagement Rings", icon: <Circle size={16} /> },
  { id: 130402, parentId: 1304, name: "Wedding Bands",    icon: <Circle size={16} /> },
  { id: 130403, parentId: 1304, name: "Statement Rings",  icon: <Circle size={16} /> },
  { id: 130404, parentId: 1304, name: "Stacking Rings",   icon: <Circle size={16} /> },
  { id: 130405, parentId: 1304, name: "Signet Rings",     icon: <Circle size={16} /> },
];

/* ───────────────────────────────────────────────────────────
   FashionShoes   (parentId: 14)
   Merged from Women's / Men's / Kids' shoe ranges.
   ─────────────────────────────────────────────────────────── */
export const FashionShoes: CategoryItem[] = [
  { id: 1401, parentId: 14, name: "Trainers",             icon: <Footprints size={16} /> },
  { id: 1402, parentId: 14, name: "Boots",                icon: <Footprints size={16} /> },
  { id: 1403, parentId: 14, name: "Ankle Boots",          icon: <Footprints size={16} /> },
  { id: 1404, parentId: 14, name: "Chelsea Boots",        icon: <Footprints size={16} /> },
  { id: 1405, parentId: 14, name: "Knee-High & Over-the-Knee Boots", icon: <Footprints size={16} /> },
  { id: 1406, parentId: 14, name: "Heels",                icon: <Footprints size={16} /> },
  { id: 1407, parentId: 14, name: "Pumps",                icon: <Footprints size={16} /> },
  { id: 1408, parentId: 14, name: "Wedges",               icon: <Footprints size={16} /> },
  { id: 1409, parentId: 14, name: "Platform Shoes",       icon: <Footprints size={16} /> },
  { id: 1410, parentId: 14, name: "Loafers",              icon: <Footprints size={16} /> },
  { id: 1411, parentId: 14, name: "Derby & Oxford Shoes", icon: <Footprints size={16} /> },
  { id: 1412, parentId: 14, name: "Monk Shoes",           icon: <Footprints size={16} /> },
  { id: 1413, parentId: 14, name: "Smart Shoes",          icon: <Footprints size={16} /> },
  { id: 1414, parentId: 14, name: "Boat Shoes",           icon: <Footprints size={16} /> },
  { id: 1415, parentId: 14, name: "Desert Boots",         icon: <Footprints size={16} /> },
  { id: 1416, parentId: 14, name: "Sandals",              icon: <Footprints size={16} /> },
  { id: 1417, parentId: 14, name: "Slides & Flip Flops",  icon: <Footprints size={16} /> },
  { id: 1418, parentId: 14, name: "Espadrilles",          icon: <Footprints size={16} /> },
  { id: 1419, parentId: 14, name: "Mules",                icon: <Footprints size={16} /> },
  { id: 1420, parentId: 14, name: "Slippers",             icon: <Footprints size={16} /> },
  { id: 1421, parentId: 14, name: "School Shoes",         icon: <Footprints size={16} /> },
];

/* ───────────────────────────────────────────────────────────
   FashionBags   (parentId: 15)
   Merged from Women's / Men's bag ranges.
   ─────────────────────────────────────────────────────────── */
export const FashionBags: CategoryItem[] = [
  { id: 1501, parentId: 15, name: "All Bags",           icon: <ShoppingBag /> },
  { id: 1502, parentId: 15, name: "Tote Bags",          icon: <ShoppingBag /> },
  { id: 1503, parentId: 15, name: "Shoulder Bags",      icon: <ShoppingBag /> },
  { id: 1504, parentId: 15, name: "Cross-Body Bags",    icon: <ShoppingBag /> },
  { id: 1505, parentId: 15, name: "Mini Bags",          icon: <ShoppingBag /> },
  { id: 1506, parentId: 15, name: "East-West Bags",     icon: <ShoppingBag /> },
  { id: 1507, parentId: 15, name: "Clutch Bags",        icon: <ShoppingBag /> },
  { id: 1508, parentId: 15, name: "Bucket Bags",        icon: <ShoppingBag /> },
  { id: 1509, parentId: 15, name: "Hobo Bags",          icon: <ShoppingBag /> },
  { id: 1510, parentId: 15, name: "Saddle Bags",        icon: <ShoppingBag /> },
  { id: 1511, parentId: 15, name: "Top Handle Bags",    icon: <ShoppingBag /> },
  { id: 1512, parentId: 15, name: "Belt Bags",          icon: <ShoppingBag /> },
  { id: 1513, parentId: 15, name: "Beach Bags",         icon: <ShoppingBag /> },
  { id: 1514, parentId: 15, name: "Backpacks",          icon: <Backpack /> },
  { id: 1515, parentId: 15, name: "Briefcases",         icon: <Briefcase size={16} /> },
  { id: 1516, parentId: 15, name: "Messenger Bags",     icon: <ShoppingBag /> },
  { id: 1517, parentId: 15, name: "Luggage & Holdalls", icon: <Briefcase size={16} /> },
  { id: 1518, parentId: 15, name: "Wash Bags",          icon: <Package size={16} /> },
];



/* ═══════════════════════════════════════════════════════════
   AGGREGATED EXPORTS (handy for lookups / mega menus)
═══════════════════════════════════════════════════════════ */
export const AllFashionProducts: CategoryItem[] = [
  ...FashionClothing,
  ...FashionAccessories,
  ...FashionJewellery,
  ...FashionShoes,
  ...FashionBags,
];